import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _values from 'lodash/values';

import { CALENDAR_THEMES } from '../../constants';
import './month_day.scss';

class MonthDay extends Component {
  constructor(props) {
    super(props);

    this.CLASS_NAME = 'brzw-calendar-month-day';
  }

  render() {
    const { containerClassName, day, theme, month } = this.props;

    return (
      <div
        className={classnames(this.CLASS_NAME, containerClassName, {
          [`${this.CLASS_NAME}--theme-${theme}`]: theme,
        })}
      >
        <span className={`${this.CLASS_NAME}__value`}>{day}</span>

        {theme === CALENDAR_THEMES.THIRD && month && (
          <span className={`${this.CLASS_NAME}__first-month`}>{month}</span>
        )}
      </div>
    );
  }
}

MonthDay.propTypes = {
  containerClassName: PropTypes.string,
  day: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  month: PropTypes.string,
  theme: PropTypes.oneOf(_values(CALENDAR_THEMES)),
};

MonthDay.defaultProps = {
  containerClassName: '',
  day: '',
  theme: CALENDAR_THEMES.PRIMARY,
};

export default MonthDay;
